function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2483 16.5588C20.5639 16.8744 21.1034 16.6498 21.1018 16.2035L21.0869 12.0132V5.06579C21.0869 3.78681 20.0501 2.75 18.7711 2.75H7.9641C6.68513 2.75 5.64832 3.78681 5.64832 5.06579V8.25H11.6666C13.3235 8.25 14.6666 9.59315 14.6666 11.25V14.3289H18.0184L20.2483 16.5588Z",
  fill: "#FAFAFA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.81958 16.5V11.9167C1.81958 10.9042 2.64039 10.0833 3.65291 10.0833H10.9862C11.9988 10.0833 12.8196 10.9042 12.8196 11.9167V16.5C12.8196 17.5125 11.9988 18.3333 10.9862 18.3333H3.759L2.68928 19.3572C2.37128 19.6616 1.84355 19.4362 1.84355 18.996V16.7972C1.82778 16.7005 1.81958 16.6012 1.81958 16.5Z",
  fill: "#EC3642"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 5.5,
  y: 12.8333,
  width: 5.5,
  height: 0.916667,
  rx: 0.458333,
  fill: "#FAFAFA"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 8.25,
  y: 14.6667,
  width: 2.75,
  height: 0.916666,
  rx: 0.458333,
  fill: "#FAFAFA"
});

function SvgGroupChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChat);
export default __webpack_public_path__ + "static/media/group-chat.cef9ee7b.svg";
export { ForwardRef as ReactComponent };